import React, { useCallback, useState } from 'react';
import {
  Brain,
  Cloud,
  Code,
  CreditCard,
  Database,
  GitBranch,
  LayoutGrid,
  Palette,
  Server,
  Sparkles,
} from 'lucide-react';
import { useLocale } from '../context/LocaleContext';

const iconMap = {
  code: Code,
  server: Server,
  layoutGrid: LayoutGrid,
  cloud: Cloud,
  database: Database,
  palette: Palette,
  gitBranch: GitBranch,
  sparkles: Sparkles,
  brain: Brain,
  creditCard: CreditCard,
};

const SkillFlipCard = ({ skillGroup, index }) => {
  const { t } = useLocale();
  const [flipped, setFlipped] = useState(false);
  const Icon = iconMap[skillGroup.icon];
  const indexLabel = String(index + 1).padStart(2, '0');

  const toggleFlip = useCallback(() => {
    if (typeof window !== 'undefined' && window.matchMedia('(hover: none)').matches) {
      setFlipped((current) => !current);
    }
  }, []);

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleFlip();
      }
    },
    [toggleFlip],
  );

  return (
    <article
      className={`skill-flip-card${flipped ? ' is-flipped' : ''}`}
      onClick={toggleFlip}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
      aria-expanded={flipped}
      aria-label={`${skillGroup.category} — ${t('skills_flip_hint')}`}
    >
      <div className="skill-flip-card__inner">
        <div className="skill-flip-card__face skill-flip-card__face--front">
          <span className="skill-flip-card__watermark" aria-hidden="true">
            {indexLabel}
          </span>
          <div className="skill-flip-card__front-top">
            <span className="skill-flip-card__index">{indexLabel}</span>
            <div className={`skill-flip-card__icon ${skillGroup.iconColor}`}>
              {Icon ? <Icon size={18} strokeWidth={1.75} /> : null}
            </div>
          </div>
          <h3 className="skill-flip-card__title">{skillGroup.category}</h3>
          <p className="skill-flip-card__desc">{skillGroup.description}</p>
          <p className="skill-flip-card__hint">
            <span className="skill-flip-card__hint-desktop">{t('skills_flip_hint')}</span>
            <span className="skill-flip-card__hint-touch">{t('skills_flip_hint_touch')}</span>
          </p>
        </div>

        <div className="skill-flip-card__face skill-flip-card__face--back">
          <div className="skill-flip-card__back-head">
            <span className="skill-flip-card__index">{indexLabel}</span>
            <h3 className="skill-flip-card__back-title">{skillGroup.category}</h3>
          </div>
          <ul className="skill-flip-card__skills">
            {skillGroup.items.map((skill) => (
              <li key={skill.name} className="skill-flip-card__skill">
                <div className="skill-flip-card__skill-row">
                  <span className="skill-flip-card__skill-name">{skill.name}</span>
                  <span className="skill-flip-card__skill-level">{skill.level}%</span>
                </div>
                <div className="rihen-meter">
                  <div className="rihen-meter__fill" style={{ width: `${skill.level}%` }} />
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </article>
  );
};

export default SkillFlipCard;
